@if ((userLogin$ | async) === null) {
  <div class="main-div">
    <unesp-core-home></unesp-core-home>
  </div>
}

@if ((userLogin$ | async)) {
  <div fxLayout="column">
    <unesp-core-home style="display: none;"></unesp-core-home>
    <div fxLayout="row wrap" fxLayoutAlign="space-between" fxLayoutAlign="center">
      <div>
        @if ((candidatoInativo | async)) {
          <mat-card appearance="outlined" class="dashboard-card warning-snackbar dashboard-card-user aviso">
            <mat-card-header>
              <mat-card-title>
                Aviso
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <p>Seu usuário ainda não está habilitado para inscrições!</p>
              <p>Por favor, acesse o menu <strong>'Área do candidato'</strong> -> submenu <strong>'Perfil'</strong> para realizar a habilitação.</p>
            </mat-card-content>
          </mat-card>
        }
        <mat-card appearance="outlined" class="dashboard-card dashboard-card-user">
          <mat-card-header>
            <mat-card-title>
              Olá, {{userLogin?.nomeUsuario}}!
              <div style="float: right; position: absolute; right:5px; top:5px;">
                <button mat-icon-button color="{{infoCardVisibility?'primary':'secondary'}}" aria-label="Visualizar ou Esconder informações"
                  (click)="toggleInfoCardVisibility()">
                  <mat-icon>{{infoCardVisibility?'visibility':'visibility_off'}}</mat-icon>
                </button>
              </div>
            </mat-card-title>
            <mat-card-subtitle>Utilize o menu para acessar as funcionalidades</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <div>
              <b>Perfis ativos:</b>
              &nbsp;{{textoPerfis}}
            </div>
            @if (!infoCardVisibility) {
              <div>
                <mat-icon>more_horiz</mat-icon>
              </div>
            } @else {
              <div>
                <b>Usuário:</b> {{userLogin?.identificacao}} <br/>
              </div>
            }
          </mat-card-content>
          @if (infoCardVisibility) {
            <mat-card-footer>
              Caso as informações estejam erradas, contate a equipe.
            </mat-card-footer>
          }
        </mat-card>
      </div>
    </div>
  </div>
}
